import React from 'react';
import { ModalTheme } from '../../../../components/modal/index.jsx';
import { useForm } from 'react-hook-form';
import { ContainerButton } from '../../../../styles/global-style.js';
import { TextLarge, TextSmall } from '../../../../components/text/index.jsx';
import { ButtonTheme, RenderForm } from '../../../../components/index.js';
import { FORM_REJECT } from '../form/index.js';
import { useDeleteClaim } from '../hooks/useDeleteClaim.js';
import { useEffect } from 'preact/hooks';

export const RejectMessage = ({ open, onToggle, claimData }) => {
  const { control, setValue, getValues, handleSubmit } = useForm({});

  const { mutate: rejectClaim } = useDeleteClaim();

  useEffect(() => {
    if (claimData) {
      setValue('claimId', claimData?.claimId);
    }
  }, [claimData]);

  const onSubmit = (values) => {
    rejectClaim(values);
    onToggle({ defaultValue: '' });
  };

  return (
    <ModalTheme title=" " open={open} onToggle={onToggle}>
      <div style={{ textAlign: 'center', width: '100%' }}>
        <TextLarge text="หมายเหตุ" />
      </div>
      <div style={{ textAlign: 'left', width: '100%' }}>
        <TextSmall text={'ชื่อ : ' + claimData?.fullName} />
        <TextSmall text={'เลขที่เคลม : ' + claimData?.claimCode} />
      </div>
      <RenderForm
        control={control}
        forms={FORM_REJECT()}
        setValue={setValue}
        getValues={getValues}
      />
      <ContainerButton right>
        <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
        <ButtonTheme useFor="CANCEL" onClick={onToggle} />
      </ContainerButton>
    </ModalTheme>
  );
};
